export default __webpack_public_path__ + "assets/images/ba0b6740e4129ad4c9d4b80161ea7e5d.jpg";